import React, { useRef, useState } from 'react';
import { uploadProfilePic, removeProfilePic } from '../api/userApi';

const ProfilePicUpload = ({ currentPicUrl, onUploadSuccess }) => {
  const [preview, setPreview] = useState(currentPicUrl || null);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // ✅ Show preview immediately
    const localPreview = URL.createObjectURL(file);
    setPreview(localPreview);

    try {
      setUploading(true);
      const data = await uploadProfilePic(file);
      onUploadSuccess(data.profilePicUrl); // ✅ tell parent the new URL
    } catch (err) {
      console.error('Upload failed:', err);
      alert('Upload failed. Please try again.');
      setPreview(currentPicUrl); // rollback preview
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = async (e) => {
    e.stopPropagation(); // ✅ prevent triggering file input
    if (!window.confirm('Remove profile picture?')) return;
    try {
      await removeProfilePic();
      setPreview(null);
      onUploadSuccess(null); // ✅ tell parent pic is gone
    } catch (err) {
      console.error('Remove failed:', err);
      alert('Could not remove photo.');
    }
  };

  return (
    <div className="profile-pic-wrapper">
      {/* ✅ Clickable area for upload */}
      <div onClick={() => fileInputRef.current.click()} style={{ cursor: 'pointer' }}>
        {preview ? (
          <img src={preview} alt="Profile" className="profile-pic" />
        ) : (
          <div className="profile-pic-placeholder">
            <span>👤</span>
          </div>
        )}

        {uploading && (
          <div className="profile-pic-uploading">
            <span>Uploading...</span>
          </div>
        )}

        <div className="profile-pic-overlay">
          <span>📷</span>
        </div>
      </div>

      {/* ✅ Remove button — only shows if there's a pic */}
      {preview && !uploading && (
        <button onClick={handleRemove} className="profile-pic-remove-btn" title="Remove photo">
          ✕
        </button>
      )}

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        accept="image/*"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default ProfilePicUpload;
